import ToolToggleBlock from './ToolToggleBlock';

class ToolToggleHeading3 extends ToolToggleBlock {
  static toolName = 'Heading 3';
  static iconClass = 'fa-regular fa-h3';
  static blockType = 'h3';
}

export default ToolToggleHeading3;
